<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <CInput class="mt-3" v-model="form.firstname"  label="Firstname"   />
            <CInput v-model="form.lastname" label="Lastname"   />
            <CInput v-model="form.dob" type="date" label="Date of Birth"   />
            <CInput v-model="form.email"  label="Email"   />
            <CInput v-model="form.address1" label="Address"   />
            <CInput v-model="form.mobile" label="Mobile Phone"   />
            <label> iCare </label>
            <CRow>
              <CCol sm="8">
                <b-form-select id="icare_id" v-model="form.icare_id"  :options="options_icare"></b-form-select>
              </CCol>
              <CCol sm="4">
                <CButton class="btn btn-sm mt-1" type="button" @click="clear('icare_id')"  variant="outline" color="dark">Remove iCare</CButton>
              </CCol>
            </CRow>
          </CCol> 
        </CRow>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Update</CButton>
        
        </template>
        <!-- <pre> {{form | json}} </pre> -->
    </CModal>
  </form>
</template>
<script>
import EventBus from '@/eventBus';
import visitor from '@/services/visitor'
import icare from '@/services/icare'
import moment from 'moment'

export default {
name: 'covenantmodal',
  data () {
   return {
      show: false,
      title: 'Default Title',
      mode: '',
      options_icare: [],
      form:{
        id:'',
        uuid: '',
        firstname: '',
        lastname: '',
        email: '',
        mobile:'',
        dob: '',
        address1: '',
        icare_id:'',
      }
    }
  },

  mounted (){
     
   },
  
  created () {
    var self = this;
    
    EventBus.$on('OPEN_MODAL_EDIT_VISITOR', (params) => {
      if(params.data){
        visitor.getVisitorbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = params.data;
          self.form.firstname = res.data.firstname;
          self.form.lastname = res.data.lastname;
          self.form.email = res.data.email;
          self.form.dob = res.data.dob;
          self.form.mobile = res.data.mobile;
          self.form.address1 = res.data.address1;
          self.form.icare_id = res.icare[0]?.icare_id;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
         self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.id = "";
      self.form.uuid = "";
      self.form.firstname = "";
      self.form.mobile = "";
      self.form.lastname = "";
      self.form.dob = "";
      self.form.email = "";
      self.form.address1 = "";
      }
    });
    this.form.uuid = this.$route.query.Pud
    this.options_icare = []
    icare.getIcare()
    .then(res => {
      for (let i=0; i <= res.data.length-1; i++){
        //alert
        this.options_icare.push({text: res.data[i].name, value:res.data[i].id})
      }
    }).catch((er) =>{
      var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
    })
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
   update(id){
      this.show = false;
      if( this.form.dob != null ){this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')}
      if( this.form.icare_id == null){this.form.icare_id = '0'}
      

      visitor.updateVisitor(id,this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        this.showModal= false
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        console.log(err.response.data.errors)
      })

    },  
    clear(id){
      if(id == 'icare_id'){this.form.icare_id = '0'};
      
    }, 
  
   
  }
}
</script>

<style>

</style>